"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Slider_1 = __importDefault(require("../../components/Slider"));
var Icon_1 = __importDefault(require("../Icon"));
var formatTime_1 = require("../../utils/formatTime");
var react_popper_1 = require("react-popper");
var useClickOutside_1 = __importDefault(require("../../hooks/useClickOutside"));
var VideoPlayerControls = (function (_a) {
    var onPlay = _a.onPlay, onPause = _a.onPause, onSeek = _a.onSeek, onVolumeChange = _a.onVolumeChange, onFullScreenToggle = _a.onFullScreenToggle, onViewChange = _a.onViewChange, onDownload = _a.onDownload, playback = _a.playback, disabled = _a.disabled, showViewButton = _a.showViewButton, allowDownload = _a.allowDownload;
    var _b = __read(react_1.default.useState(false), 2), showVolumeSlider = _b[0], setShowVolumeSlider = _b[1];
    var popperRef = (0, react_1.useRef)(null);
    var triggerRef = (0, react_1.useRef)(null);
    var ref = (0, useClickOutside_1.default)(function () {
        setShowVolumeSlider(false);
    });
    var handleDisabledFunction = function (fn) {
        return disabled ? function () { } : fn;
    };
    var _c = (0, react_popper_1.usePopper)(triggerRef.current, popperRef.current, {
        placement: 'top-start',
        modifiers: [
            {
                name: "offset",
                enabled: true,
                options: {
                    offset: [0, 0],
                },
            },
        ],
    }), styles = _c.styles, attributes = _c.attributes, update = _c.update;
    var handleVolumeClick = function () {
        if (disabled) {
            return;
        }
        setShowVolumeSlider(!showVolumeSlider);
        if (update) {
            update();
        }
    };
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("ui-theme ui-video-player-controls", disabled && "disabled") },
        playback.playing ? (react_1.default.createElement("div", { onClick: handleDisabledFunction(onPause), role: "button", className: "ui-video-player-button" },
            react_1.default.createElement(Icon_1.default, { icon: "pause", fill: true }))) : (react_1.default.createElement("div", { onClick: handleDisabledFunction(onPlay), role: "button", className: "ui-video-player-button" },
            react_1.default.createElement(Icon_1.default, { icon: "play_arrow", fill: true }))),
        react_1.default.createElement("div", { ref: ref },
            react_1.default.createElement("div", { onClick: handleVolumeClick, role: "button", className: "ui-video-player-button", ref: triggerRef },
                react_1.default.createElement(Icon_1.default, { icon: "volume_up" })),
            react_1.default.createElement("div", __assign({ ref: popperRef, style: __assign(__assign({}, styles.popper), { display: showVolumeSlider ? 'block' : 'none' }), className: "ui-video-player-volume-slider-container" }, attributes.popper),
                react_1.default.createElement(Slider_1.default, { onChange: onVolumeChange, value: playback.volume, vertical: true, paintProgress: true, className: "ui-video-player-volume-slider" }))),
        react_1.default.createElement("span", { className: "ui-video-player-current-time" }, (0, formatTime_1.formatTime)(playback.currentTime * 1000)),
        react_1.default.createElement(Slider_1.default, { onChange: onSeek, disabled: disabled, paintProgress: true, value: playback.currentTime / playback.duration }),
        react_1.default.createElement("span", { className: "ui-video-player-total-time" }, (0, formatTime_1.formatTime)(playback.duration * 1000)),
        showViewButton && (react_1.default.createElement("div", { onClick: handleDisabledFunction(onViewChange), role: "button", className: "ui-video-player-button" },
            react_1.default.createElement(Icon_1.default, { icon: playback.view == 'gallery' ? 'grid_view' : 'featured_video' }))),
        react_1.default.createElement("div", { onClick: handleDisabledFunction(onFullScreenToggle), role: "button", className: "ui-video-player-button" },
            react_1.default.createElement(Icon_1.default, { icon: playback.fullscreen ? 'fullscreen_exit' : 'fullscreen' })),
        allowDownload && (react_1.default.createElement("div", { onClick: handleDisabledFunction(onDownload), role: "button", className: "ui-video-player-button" },
            react_1.default.createElement(Icon_1.default, { icon: "download" })))));
});
exports.default = VideoPlayerControls;
